/**
 * Notice sorting and retrieval utilities
 */

/**
 * Sort notices by posted date descending (newest first)
 * Generic function that works with any notice type that has a posted_date field
 */
export function sortNoticesByDate<T extends { posted_date: string }>(
  notices: T[],
): T[] {
  return [...notices].sort(
    (a, b) =>
      new Date(b.posted_date).getTime() - new Date(a.posted_date).getTime(),
  )
}

/**
 * Sort notices by a custom date field descending (newest first)
 * Use when the date field is named differently (e.g., post_date for grants)
 */
export function sortNoticesByDateField<T>(
  notices: T[],
  dateField: keyof T,
): T[] {
  return [...notices].sort((a, b) => {
    const dateA = a[dateField]
    const dateB = b[dateField]
    if (typeof dateA !== 'string' || typeof dateB !== 'string') return 0
    return new Date(dateB).getTime() - new Date(dateA).getTime()
  })
}
